module.exports = __webpack_public_path__ + "static/img/exposure-pc-3.abe056aa.png";